export const columna = [
	
	// {
	// 	"nombre": "Noticias.",
	// 	"imagen": 'noticias/lunescivico.jpg',
	//    "funcion": 'Lunes Cívico.',
	// 	"url" : 'https://www.facebook.com/reel/1433045694625698',
	// },
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/videosemanal.jpg',
	   "funcion": 'Video de la semana',
		"url" : 'https://www.facebook.com/SecretariaContraloriaHgo/videos/10097824880317692?locale=es_LA',
	},
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/voluntariado.jpg',
	   "funcion": 'Voluntariado.',
		"url" : 'https://www.facebook.com/SecretariaContraloriaHgo/videos/24364530693212060?locale=es_LA',
	}

	
	// {
	// 	"nombre": " Padrón de Empresas Íntegras",
	// 	"imagen": 'noticias/Empresas.jpg',
	//    "funcion": '"25 de Enero"',
	// 	"url" : 'https://www.facebook.com/watch/?v=1347448829582233&vanity=SecretariaContraloriaHgo&_rdr',
	// },
	// {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]